<template>
  <v-main class="fill-height d-flex v-application v-application v-application--is-ltr theme--light">
    <div data-app style="flex: 1 1 auto;
    max-width: 100%;
    position: relative;
display: flex;
flex-direction: column;
height: 100%;">
      <v-row class="m-0" style="flex: 0 0 auto;">
        <v-col class="pt-3 pb-0 text-right" >
          <b-button v-if="saveNeeded" variant="warning" class="btn-pill font-lg" style="color: white" @click="onCancel">
            Abbrechen
          </b-button>
          <b-button v-if="saveNeeded" variant="success" class="btn-pill font-lg ml-2" style="color: white" @click="onSave">
            Speichern
          </b-button>
          <b-button variant="primary" class="btn-pill font-lg ml-2" style="color: white" v-on:click="onBack">
            &nbsp;Zurück
          </b-button>

        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-sheet
              color="white"
              elevation="1"
              class="m-2"
          >
            <v-row>
              <v-col class="pl-8">
                <v-card-title class="p-0 mb-5">Lohnartenzuweisung</v-card-title>
                <v-row>
                  <v-col  md="8">
                    <v-card-title class="p-0" style="font-size: 1rem">Überstundenvortrag</v-card-title>
                  </v-col>
                  <v-col>
                    <v-select
                        class="hide-label"
                        :items="last_year"
                        item-value="id"
                        item-text="name"
                        v-model="ueb_vortrag.web_server_id"
                        @input="saveNeeded = true"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col  md="8">
                    <v-card-title class="p-0" style="font-size: 1rem">Überstunden geleistet</v-card-title>
                  </v-col>
                  <v-col>
                    <v-select
                        class="hide-label"
                        :items="overtimes"
                        item-value="id"
                        item-text="name"
                        v-model="ueb_geleisted.web_server_id"
                        @input="saveNeeded = true"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col  md="8">
                    <v-card-title class="p-0" style="font-size: 1rem">Überstunden abgefeiert</v-card-title>
                  </v-col>
                  <v-col>
                    <v-select
                        class="hide-label"
                        :items="absences"
                        item-value="id"
                        item-text="name"
                        v-model="ueb_abgefeiert.web_server_id"
                        @input="saveNeeded = true"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col  md="8">
                    <v-card-title class="p-0" style="font-size: 1rem">Urlaubvortrag</v-card-title>
                  </v-col>
                  <v-col>
                    <v-select
                        class="hide-label"
                        :items="last_year"
                        item-value="id"
                        item-text="name"
                        v-model="url_vortrag.web_server_id"
                        @input="saveNeeded = true"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col  md="8">
                    <v-card-title class="p-0" style="font-size: 1rem">Urlaubsanspruch</v-card-title>
                  </v-col>
                  <v-col>
                    <v-select
                        class="hide-label"
                        :items="last_year"
                        item-value="id"
                        item-text="name"
                        v-model="url_anspruch.web_server_id"
                        @input="saveNeeded = true"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col  md="8">
                    <v-card-title class="p-0" style="font-size: 1rem">Urlaub genommen</v-card-title>
                  </v-col>
                  <v-col>
                    <v-select
                        class="hide-label"
                        :items="absences"
                        item-value="id"
                        item-text="name"
                        v-model="url_genommen.web_server_id"
                        @input="saveNeeded = true"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-col>
              <v-divider vertical/>
              <v-col>
                <v-card-title class="p-0 mb-5">Überstundenberechnung</v-card-title>
                <v-row class="pl-2 pr-2">
                  <v-col  md="8">
                    <v-card-title class="p-0" style="font-size: 1rem">Art der Berechnung</v-card-title>
                    <v-subheader style="height: auto; padding-left: 0">
                      Gibt an wie/ob Überstundenzuschläge berechnet werden sollen.
                    </v-subheader>
                  </v-col>
                  <v-col>
                    <v-select
                        class="hide-label"
                        :items="uebTypeSelects"
                        v-model="ueb_settings_all.ueb_surcharge_type"
                        @input="saveNeeded = true; setDefaults();"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row class="pl-2 pr-2" v-if="ueb_settings_all.ueb_surcharge_type === '3'">
                  <v-col  md="8">
                    <v-card-title class="p-0" style="font-size: 1rem">Art des wöchentlichen Solls</v-card-title>
                    <v-subheader style="height: auto; padding-left: 0">
                      Entweder Summe der Arbeitszeiten oder fester Wert.
                    </v-subheader>
                  </v-col>
                  <v-col>
                    <v-select
                        class="hide-label"
                        :items="weeklySumSelect"
                        v-model="ueb_settings_all.weekly_sum_type"
                        @input="saveNeeded = true"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row class="pl-2 pr-2" v-if="ueb_settings_all.ueb_surcharge_type === '3' && ueb_settings_all.weekly_sum_type === 'fixed'">
                  <v-col  md="8">
                    <v-card-title class="p-0" style="font-size: 1rem">Wert des fixen Solls</v-card-title>
                    <v-subheader style="height: auto; padding-left: 0">
                      Ab welcher Ist-Zeit werden Zulagen berechnet.
                    </v-subheader>
                  </v-col>
                  <v-col>
                    <v-text-field
                        class="hide-label"
                        v-model="ueb_settings_all.fixed_sum"
                        @input="saveNeeded = true"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="pl-2 pr-2" v-if="ueb_settings_all.ueb_surcharge_type === '4'">
                  <v-col  md="8">
                    <v-card-title class="p-0" style="font-size: 1rem">Rahmen für die Zuschlagsberechnung</v-card-title>
                    <v-subheader style="height: auto; padding-left: 0">
                      Überstunden die außerhalb dieses Rahmens erbracht werden sind zuschlagspflichtig.
                    </v-subheader>
                  </v-col>
                  <v-col>
                    <v-text-field
                        class="hide-label"
                        :rules="hours_rules"
                        v-model="ueb_settings_all.time_frame"
                        hint="Format: HH:MM-HH:MM"
                        v-windows-time
                        @input="saveNeeded = true;"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col  md="8">
                    <v-card-title class="p-0" style="font-size: 1rem">Zuschlag Lohnkonto</v-card-title>
                  </v-col>
                  <v-col>
                    <v-select
                        class="hide-label"
                        :items="salary_surcharges"
                        item-value="id"
                        item-text="name"
                        v-model="ueb_lohn_setting.ueb_surcharge"
                        @input="saveNeeded = true"
                    ></v-select>
                  </v-col>
                </v-row>
                  <v-row>
                    <v-col  md="8">
                      <v-card-title class="p-0" style="font-size: 1rem">Zuschlag Zeitkonto</v-card-title>
                    </v-col>
                    <v-col>
                      <v-select
                          class="hide-label"
                          :items="time_surcharges"
                          item-value="id"
                          item-text="name"
                          v-model="ueb_lohn_setting.ueb_time_surcharge"
                          @input="saveNeeded = true"
                      ></v-select>
                    </v-col>
                </v-row>
                <v-row class="pl-2 pr-2">
                  <v-col  md="8">
                    <v-card-title class="p-0" style="font-size: 1rem">nach Beschäftigungsverhältnis</v-card-title>
                    <v-subheader style="height: auto; padding-left: 0">
                      Überstunden und Überstundenzuschläge werden abhängig vom Beschäftigungsverhältnis berechnet.
                    </v-subheader>
                  </v-col>
                  <v-col>
                    <v-select
                        class="hide-label"
                        :items="trueFalseSelects"
                        item-value="value"
                        item-text="text"
                        v-model="ueb_lohn_setting.ueb_geleistet_use_employment_type"
                        @input="saveNeeded = true"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row class="pl-2 pr-2" v-for="(item, index) in ueb_geleistet_settings" :key="'ueb-' + index" v-if="ueb_lohn_setting.ueb_geleistet_use_employment_type || index === ''">
                  <v-col  md="8">
                    <v-card-title class="p-0" style="font-size: 1rem">Buchungen: {{index === '' ? 'Allgemein' : index}}</v-card-title>
                    <v-subheader style="height: auto; padding-left: 0">
                      Falls "Überstunden geleistet" gebucht werden soll, bitte auch auswählen. Der Standardzuschlag muss nicht ausgewählt werden.
                    </v-subheader>
                  </v-col>
                  <v-col>
                    <v-select
                        class="hide-label"
                        :items="possibleLohns"
                        item-value="id"
                        item-text="name"
                        multiple
                        chips
                        v-model="ueb_geleistet_settings[index].lohn_ids"
                        @input="saveNeeded = true"
                        :key="'ueb-lohns-' + index"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-sheet>
        </v-col>

      </v-row>
    </div>
  </v-main>
</template>


<script>
import {Redirect_500, Redirect_Login, Server_URL_ZK} from "@/shared/utils";
import _orderBy from "lodash/orderBy";
import IMask from 'imask'; // <-- Add this line

export default {
  name: "UebSettings",
  directives: {
    windowsTime: {
      inserted(el) {
        const input = el.querySelector('input');
        if (!input) return;

        if (!input.value) {
          input.value = '00:00-00:00';
          input.dispatchEvent(new Event('input', { bubbles: true }));
        }

        // 1. Highlight specific block on click
        input.addEventListener('click', () => {
          const pos = input.selectionStart;
          if (pos <= 2) input.setSelectionRange(0, 2);
          else if (pos <= 5) input.setSelectionRange(3, 5);
          else if (pos <= 8) input.setSelectionRange(6, 8);
          else input.setSelectionRange(9, 11);
        });

        // 2. Intercept keystrokes (Same as before)
        input.addEventListener('keydown', (e) => {
          const key = e.key;

          // Allow normal browser shortcuts to pass through to our copy/paste events
          if (key === 'Tab' || e.ctrlKey || e.metaKey) return;

          e.preventDefault();

          let pos = input.selectionStart;
          let val = input.value;

          // NAVIGATION
          if (['ArrowRight', ':', '-'].includes(key)) {
            if (pos <= 2) input.setSelectionRange(3, 5);
            else if (pos <= 5) input.setSelectionRange(6, 8);
            else if (pos <= 8) input.setSelectionRange(9, 11);
            return;
          }
          if (key === 'ArrowLeft') {
            if (pos >= 9) input.setSelectionRange(6, 8);
            else if (pos >= 6) input.setSelectionRange(3, 5);
            else if (pos >= 3) input.setSelectionRange(0, 2);
            return;
          }

          // DELETING
          if (['Backspace', 'Delete'].includes(key)) {
            if (input.selectionStart !== input.selectionEnd) {
              let s = input.selectionStart;
              let end = input.selectionEnd;
              let newVal = val;
              for (let i = s; i < end; i++) {
                if (newVal[i] !== ':' && newVal[i] !== '-') {
                  newVal = newVal.substring(0, i) + '0' + newVal.substring(i + 1);
                }
              }
              input.value = newVal;
              input.dispatchEvent(new Event('input', { bubbles: true }));
              input.setSelectionRange(s, s);
            } else if (key === 'Backspace' && pos > 0) {
              pos--;
              if (val[pos] === ':' || val[pos] === '-') pos--;
              input.value = val.substring(0, pos) + '0' + val.substring(pos + 1);
              input.dispatchEvent(new Event('input', { bubbles: true }));
              input.setSelectionRange(pos, pos);
            }
            return;
          }

          // TYPING NUMBERS
          if (/^\d$/.test(key)) {
            if (pos === 2 || pos === 5 || pos === 8) pos++;
            if (pos >= 11) return;

            input.value = val.substring(0, pos) + key + val.substring(pos + 1);
            input.dispatchEvent(new Event('input', { bubbles: true }));

            pos++;

            if (pos === 2 || pos === 5 || pos === 8) {
              pos++;
              input.setSelectionRange(pos, pos + 2);
            } else {
              input.setSelectionRange(pos, pos);
            }
          }
        });

        // 3. OVERRIDE NATIVE COPY
        input.addEventListener('copy', (e) => {
          e.preventDefault();
          // Force the clipboard to copy the entire input string, ignoring selection
          e.clipboardData.setData('text/plain', input.value);
        });

        // 4. OVERRIDE NATIVE PASTE
        input.addEventListener('paste', (e) => {
          e.preventDefault();
          const pastedData = (e.clipboardData || window.clipboardData).getData('text');
          const cleanPaste = pastedData.trim();

          // Only overwrite if they pasted a valid time format (XX:XX-XX:XX)
          if (/^\d{2}:\d{2}-\d{2}:\d{2}$/.test(cleanPaste)) {
            input.value = cleanPaste;
            // Tell Vue to update the v-model
            input.dispatchEvent(new Event('input', { bubbles: true }));
          }
        });

      }
    }
  },

  data: () => ({
    maskOptions: {
      mask: 'HH:MM-hh:mm',
      lazy: false,
      overwrite: true,
      // Removed the placeholderChar to stop it from eating real zeroes
      blocks: {
        HH: { mask: IMask.MaskedRange, from: 0, to: 23, maxLength: 2, autofix: 'pad' },
        MM: { mask: IMask.MaskedRange, from: 0, to: 59, maxLength: 2, autofix: 'pad' },
        hh: { mask: IMask.MaskedRange, from: 0, to: 23, maxLength: 2, autofix: 'pad' },
        mm: { mask: IMask.MaskedRange, from: 0, to: 59, maxLength: 2, autofix: 'pad' }
      }
    },
    // controls
    saveNeeded: false,
    loader: undefined,
    salary_surcharges: [{id: "", name: ""}],
    time_surcharges: [{id: "", name: ""}],
    overtimes: [{id: "", name: ""}],
    absences: [{id: "", name: ""}],
    last_year: [{id: "", name: ""}],
    employment_types: ["name"],
    migrs: [{name: "", access: ""}],
    currentMigr: null,
    ueb_settings_all: {
      ueb_surcharge_type: "1",
      calc_weekly_saldo: false,
      weekly_sum_type: "sum_soll",
      fixed_sum: "39",
      use_korridor: false,
      time_frame: "07:00-18:00",
    },
    migr_ueb_settings: [],
    ueb_lohn_setting: {
      ueb_surcharge: "",
      ueb_time_surcharge: "",
      ueb_geleistet_use_employment_type: false,
    },
    ueb_geleistet_settings: {
      "": {
        lohn_ids: [],
      }
    },
    ueb_abgefeiert: {
      web_server_id: "",
    },
    ueb_geleisted: {
      web_server_id: "",
    },
    ueb_vortrag: {
      web_server_id: "",
    },
    url_anspruch: {
      web_server_id: "",
    },
    url_genommen: {
      web_server_id: "",
    },
    url_vortrag: {
      web_server_id: "",
    },
    use_diff_ueb_settings: false,


    trueFalseSelects: [{text: "Ja", value: true}, {text: "Nein", value: false}],
    uebTypeSelects: [
        {text: "Keine Berechnung", value: "0"},
      {text: "Tägliche Sollzeit", value: "1"},
      {text: "Abfeiern bis nächste Woche", value: "2"},
      {text: "Wöchentliches Soll", value: "3"},
      {text: "Täglicher Rahmen", value: "4"},
    ],
    weeklySumSelect: [
      {text: "Summe Soll", value: "sum_soll"},
      {text: "Fester Wert", value: "fixed"},
    ],
    hours_rules: [
      value => !!value || '*erforderlich',
      value => {
        const pattern = /^(?:([01]\d|2[0-3]):[0-5]\d|24:00)-(?:([01]\d|2[0-3]):[0-5]\d|24:00)$/
        return pattern.test(value) || 'Die Eingabe muss im Format HH:MM-HH:MM sein.'
      },
    ],
  }),
  computed: {
    possibleLohns() {
      let res = [];
      res = res.concat(this.salary_surcharges)
      res = res.concat(this.time_surcharges)
      res = res.concat(this.overtimes)
      return res.sort((a, b) => a.name.localeCompare(b.name));
    },
  },
  created() {
    this.showLoader();
    this.$http.get(
        Server_URL_ZK + '/zk/ueb_setting'
    ).then(this.responseOkGet, this.responseError)
  },
  methods: {
    setDefaults() {
      if (this.ueb_settings_all.ueb_surcharge_type === "3") {
        this.ueb_settings_all.weekly_sum_type = "sum_soll";
        this.ueb_settings_all.fixed_sum = "39";
      } else if (this.ueb_settings_all.ueb_surcharge_type === "4") {
        this.ueb_settings_all.use_korridor = false;
        this.ueb_settings_all.time_frame = "07:00-18:00";
      }
    },
    showLoader() {
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    responseOkGet(response) {
      this.hideLoader();
      this.saveNeeded = false;
      if (response.status === 200) {
        let res = response.body;
        console.log(res)
        this.salary_surcharges = res.salary_surcharges;
        this.time_surcharges = res.time_surcharges;
        this.overtimes = res.overtimes;
        this.absences = res.absences;
        this.last_year = res.last_year;
        this.employment_types = res.employment_types;
        this.migrs = res.migrs;
        this.ueb_settings_all = res.ueb_settings_all;
        this.ueb_lohn_setting = res.ueb_lohn_setting;
        this.ueb_geleistet_settings = res.ueb_geleistet_settings;
        this.ueb_abgefeiert = res.ueb_abgefeiert;
        this.ueb_geleisted = res.ueb_geleisted;
        this.ueb_vortrag = res.ueb_vortrag;
        this.url_anspruch = res.url_anspruch;
        this.url_genommen = res.url_genommen;
        this.url_vortrag = res.url_vortrag;
      } else {
        //window.location = Redirect_500;
      }
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        //window.location = Redirect_Login;
      } else {
        //window.location = Redirect_500;
      }
    },
    onBack() {
      window.history.back();
    },
    onSave() {
      this.ueb_settings_all.fixed_sum = this.ueb_settings_all.fixed_sum.trim().replace(",", ".")
      let req = {
        ueb_settings_all: this.ueb_settings_all,
        ueb_lohn_setting: this.ueb_lohn_setting,
        ueb_geleistet_settings: this.ueb_geleistet_settings,
        mappings: [this.ueb_abgefeiert, this.ueb_geleisted, this.ueb_vortrag, this.url_anspruch, this.url_genommen, this.url_vortrag]
      }
      this.showLoader();
      this.$http.post(
          Server_URL_ZK + '/zk/ueb_setting', req
      ).then(this.responseError, this.responseError)
    },
    onCancel() {
      this.showLoader();
      this.$http.get(
          Server_URL_ZK + '/zk/ueb_setting'
      ).then(this.responseOkGet, this.responseError)
    },
  }
}
</script>

<style scoped>
.v-input::v-deep .v-label {
  margin-bottom: 0;
}

.rb-ellipsis::v-deep > .v-input__control > .v-input__slot > .v-text-field__slot > input {
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}



</style>
